import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { InformationTooltip } from '../tooltips';
import ONBOARDING_TOOLTIP_CLASS_NAME from '../../theme/constants/tooltip';

const TitleAndInformationTooltip = ({ title, tooltipTitle, ...props }) => (
  <Typography {...props}>
    {title}
    {tooltipTitle && (
      <span style={{ marginLeft: '10px' }}>
        <InformationTooltip
          title={tooltipTitle}
          classes={{
            tooltip: ONBOARDING_TOOLTIP_CLASS_NAME,
          }}
        />
      </span>
    )}
  </Typography>
);

TitleAndInformationTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

TitleAndInformationTooltip.defaultProps = {
  tooltipTitle: null,
};

export default TitleAndInformationTooltip;
